// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file tracker/v1/reporting.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { DateRange } from "./common_pb.js";

/**
 * @generated from enum tracker.v1.MetricFormat
 */
export enum MetricFormat {
  /**
   * @generated from enum value: METRIC_FORMAT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: METRIC_FORMAT_INT = 1;
   */
  INT = 1,

  /**
   * @generated from enum value: METRIC_FORMAT_CURRENCY_USD = 2;
   */
  CURRENCY_USD = 2,

  /**
   * @generated from enum value: METRIC_FORMAT_PERCENT = 3;
   */
  PERCENT = 3,

  /**
   * @generated from enum value: METRIC_FORMAT_RATIO = 4;
   */
  RATIO = 4,

  /**
   * @generated from enum value: METRIC_FORMAT_DECIMAL = 5;
   */
  DECIMAL = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(MetricFormat)
proto3.util.setEnumType(MetricFormat, "tracker.v1.MetricFormat", [
  { no: 0, name: "METRIC_FORMAT_UNSPECIFIED" },
  { no: 1, name: "METRIC_FORMAT_INT" },
  { no: 2, name: "METRIC_FORMAT_CURRENCY_USD" },
  { no: 3, name: "METRIC_FORMAT_PERCENT" },
  { no: 4, name: "METRIC_FORMAT_RATIO" },
  { no: 5, name: "METRIC_FORMAT_DECIMAL" },
]);

/**
 * MetricDirection is which way a metric is better: its tone and a
 * comparison's Δ colour by it. UNSPECIFIED is neutral (Расход, Визиты).
 *
 * @generated from enum tracker.v1.MetricDirection
 */
export enum MetricDirection {
  /**
   * @generated from enum value: METRIC_DIRECTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Профит, CR, Апрув
   *
   * @generated from enum value: METRIC_DIRECTION_HIGHER = 1;
   */
  HIGHER = 1,

  /**
   * CPA, CPL, Боты %
   *
   * @generated from enum value: METRIC_DIRECTION_LOWER = 2;
   */
  LOWER = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(MetricDirection)
proto3.util.setEnumType(MetricDirection, "tracker.v1.MetricDirection", [
  { no: 0, name: "METRIC_DIRECTION_UNSPECIFIED" },
  { no: 1, name: "METRIC_DIRECTION_HIGHER" },
  { no: 2, name: "METRIC_DIRECTION_LOWER" },
]);

/**
 * @generated from enum tracker.v1.MetricKind
 */
export enum MetricKind {
  /**
   * @generated from enum value: METRIC_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * safe to sum across drilldown nodes
   *
   * @generated from enum value: METRIC_KIND_BASE_ADDITIVE = 1;
   */
  BASE_ADDITIVE = 1,

  /**
   * re-evaluate formula after summing
   *
   * @generated from enum value: METRIC_KIND_DERIVED = 2;
   */
  DERIVED = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(MetricKind)
proto3.util.setEnumType(MetricKind, "tracker.v1.MetricKind", [
  { no: 0, name: "METRIC_KIND_UNSPECIFIED" },
  { no: 1, name: "METRIC_KIND_BASE_ADDITIVE" },
  { no: 2, name: "METRIC_KIND_DERIVED" },
]);

/**
 * @generated from enum tracker.v1.FormulaOp
 */
export enum FormulaOp {
  /**
   * @generated from enum value: FORMULA_OP_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * operands[0] / operands[1]; absent on zero denominator
   *
   * @generated from enum value: FORMULA_OP_RATIO = 1;
   */
  RATIO = 1,

  /**
   * operands[0] - operands[1] - ...
   *
   * @generated from enum value: FORMULA_OP_DIFF = 2;
   */
  DIFF = 2,

  /**
   * @generated from enum value: FORMULA_OP_SUM = 3;
   */
  SUM = 3,

  /**
   * operands[0] * operands[1] * ...; absent when any operand is absent
   *
   * @generated from enum value: FORMULA_OP_PRODUCT = 4;
   */
  PRODUCT = 4,

  /**
   * A workspace formula: MetricFormula.expression, evaluated by the server.
   * operand_keys lists the metrics it reads.
   *
   * @generated from enum value: FORMULA_OP_EXPRESSION = 5;
   */
  EXPRESSION = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(FormulaOp)
proto3.util.setEnumType(FormulaOp, "tracker.v1.FormulaOp", [
  { no: 0, name: "FORMULA_OP_UNSPECIFIED" },
  { no: 1, name: "FORMULA_OP_RATIO" },
  { no: 2, name: "FORMULA_OP_DIFF" },
  { no: 3, name: "FORMULA_OP_SUM" },
  { no: 4, name: "FORMULA_OP_PRODUCT" },
  { no: 5, name: "FORMULA_OP_EXPRESSION" },
]);

/**
 * @generated from enum tracker.v1.DimensionFilterOp
 */
export enum DimensionFilterOp {
  /**
   * @generated from enum value: DIMENSION_FILTER_OP_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DIMENSION_FILTER_OP_IN = 1;
   */
  IN = 1,

  /**
   * @generated from enum value: DIMENSION_FILTER_OP_NOT_IN = 2;
   */
  NOT_IN = 2,

  /**
   * Case-insensitive substring: any of values.
   *
   * @generated from enum value: DIMENSION_FILTER_OP_CONTAINS = 3;
   */
  CONTAINS = 3,

  /**
   * @generated from enum value: DIMENSION_FILTER_OP_NOT_CONTAINS = 4;
   */
  NOT_CONTAINS = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(DimensionFilterOp)
proto3.util.setEnumType(DimensionFilterOp, "tracker.v1.DimensionFilterOp", [
  { no: 0, name: "DIMENSION_FILTER_OP_UNSPECIFIED" },
  { no: 1, name: "DIMENSION_FILTER_OP_IN" },
  { no: 2, name: "DIMENSION_FILTER_OP_NOT_IN" },
  { no: 3, name: "DIMENSION_FILTER_OP_CONTAINS" },
  { no: 4, name: "DIMENSION_FILTER_OP_NOT_CONTAINS" },
]);

/**
 * @generated from enum tracker.v1.MetricFilterOp
 */
export enum MetricFilterOp {
  /**
   * @generated from enum value: METRIC_FILTER_OP_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: METRIC_FILTER_OP_GT = 1;
   */
  GT = 1,

  /**
   * @generated from enum value: METRIC_FILTER_OP_GTE = 2;
   */
  GTE = 2,

  /**
   * @generated from enum value: METRIC_FILTER_OP_LT = 3;
   */
  LT = 3,

  /**
   * @generated from enum value: METRIC_FILTER_OP_LTE = 4;
   */
  LTE = 4,

  /**
   * @generated from enum value: METRIC_FILTER_OP_EQ = 5;
   */
  EQ = 5,

  /**
   * @generated from enum value: METRIC_FILTER_OP_NEQ = 6;
   */
  NEQ = 6,
}
// Retrieve enum metadata with: proto3.getEnumType(MetricFilterOp)
proto3.util.setEnumType(MetricFilterOp, "tracker.v1.MetricFilterOp", [
  { no: 0, name: "METRIC_FILTER_OP_UNSPECIFIED" },
  { no: 1, name: "METRIC_FILTER_OP_GT" },
  { no: 2, name: "METRIC_FILTER_OP_GTE" },
  { no: 3, name: "METRIC_FILTER_OP_LT" },
  { no: 4, name: "METRIC_FILTER_OP_LTE" },
  { no: 5, name: "METRIC_FILTER_OP_EQ" },
  { no: 6, name: "METRIC_FILTER_OP_NEQ" },
]);

/**
 * ReportFormula is a workspace formula: arithmetic (+ - * / and parentheses)
 * over metric keys and numbers, e.g.
 * "revenue + revenue_hold * approve_rate - cost". It may read any metric of
 * the schema except another formula. A sum treats a blank operand as zero; a
 * product or quotient with a blank operand, or a division by zero, is blank.
 *
 * @generated from message tracker.v1.ReportFormula
 */
export class ReportFormula extends Message<ReportFormula> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * key is the metric key the formula's values come back under.
   *
   * @generated from field: string key = 2;
   */
  key = "";

  /**
   * @generated from field: string label = 3;
   */
  label = "";

  /**
   * @generated from field: string expression = 4;
   */
  expression = "";

  /**
   * @generated from field: tracker.v1.MetricFormat format = 5;
   */
  format = MetricFormat.UNSPECIFIED;

  /**
   * Digits after the decimal point the value is shown with («Знаков после
   * запятой»).
   *
   * @generated from field: int32 decimals = 6;
   */
  decimals = 0;

  /**
   * «Лучше, когда больше | меньше»: which way the value's tone and a
   * comparison's Δ are coloured. UNSPECIFIED is saved as HIGHER.
   *
   * @generated from field: tracker.v1.MetricDirection better = 7;
   */
  better = MetricDirection.UNSPECIFIED;

  constructor(data?: PartialMessage<ReportFormula>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ReportFormula";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "expression", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "format", kind: "enum", T: proto3.getEnumType(MetricFormat) },
    { no: 6, name: "decimals", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "better", kind: "enum", T: proto3.getEnumType(MetricDirection) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportFormula {
    return new ReportFormula().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportFormula {
    return new ReportFormula().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportFormula {
    return new ReportFormula().fromJsonString(jsonString, options);
  }

  static equals(a: ReportFormula | PlainMessage<ReportFormula> | undefined, b: ReportFormula | PlainMessage<ReportFormula> | undefined): boolean {
    return proto3.util.equals(ReportFormula, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateReportFormulaRequest
 */
export class CreateReportFormulaRequest extends Message<CreateReportFormulaRequest> {
  /**
   * @generated from field: tracker.v1.ReportFormula formula = 1;
   */
  formula?: ReportFormula;

  constructor(data?: PartialMessage<CreateReportFormulaRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateReportFormulaRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "formula", kind: "message", T: ReportFormula },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateReportFormulaRequest {
    return new CreateReportFormulaRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateReportFormulaRequest {
    return new CreateReportFormulaRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateReportFormulaRequest {
    return new CreateReportFormulaRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateReportFormulaRequest | PlainMessage<CreateReportFormulaRequest> | undefined, b: CreateReportFormulaRequest | PlainMessage<CreateReportFormulaRequest> | undefined): boolean {
    return proto3.util.equals(CreateReportFormulaRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateReportFormulaResponse
 */
export class CreateReportFormulaResponse extends Message<CreateReportFormulaResponse> {
  /**
   * @generated from field: tracker.v1.ReportFormula formula = 1;
   */
  formula?: ReportFormula;

  constructor(data?: PartialMessage<CreateReportFormulaResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateReportFormulaResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "formula", kind: "message", T: ReportFormula },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateReportFormulaResponse {
    return new CreateReportFormulaResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateReportFormulaResponse {
    return new CreateReportFormulaResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateReportFormulaResponse {
    return new CreateReportFormulaResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateReportFormulaResponse | PlainMessage<CreateReportFormulaResponse> | undefined, b: CreateReportFormulaResponse | PlainMessage<CreateReportFormulaResponse> | undefined): boolean {
    return proto3.util.equals(CreateReportFormulaResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateReportFormulaRequest
 */
export class UpdateReportFormulaRequest extends Message<UpdateReportFormulaRequest> {
  /**
   * formula.id names the formula; key is ignored (it never changes).
   *
   * @generated from field: tracker.v1.ReportFormula formula = 1;
   */
  formula?: ReportFormula;

  constructor(data?: PartialMessage<UpdateReportFormulaRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateReportFormulaRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "formula", kind: "message", T: ReportFormula },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateReportFormulaRequest {
    return new UpdateReportFormulaRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateReportFormulaRequest {
    return new UpdateReportFormulaRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateReportFormulaRequest {
    return new UpdateReportFormulaRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateReportFormulaRequest | PlainMessage<UpdateReportFormulaRequest> | undefined, b: UpdateReportFormulaRequest | PlainMessage<UpdateReportFormulaRequest> | undefined): boolean {
    return proto3.util.equals(UpdateReportFormulaRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateReportFormulaResponse
 */
export class UpdateReportFormulaResponse extends Message<UpdateReportFormulaResponse> {
  /**
   * @generated from field: tracker.v1.ReportFormula formula = 1;
   */
  formula?: ReportFormula;

  constructor(data?: PartialMessage<UpdateReportFormulaResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateReportFormulaResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "formula", kind: "message", T: ReportFormula },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateReportFormulaResponse {
    return new UpdateReportFormulaResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateReportFormulaResponse {
    return new UpdateReportFormulaResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateReportFormulaResponse {
    return new UpdateReportFormulaResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateReportFormulaResponse | PlainMessage<UpdateReportFormulaResponse> | undefined, b: UpdateReportFormulaResponse | PlainMessage<UpdateReportFormulaResponse> | undefined): boolean {
    return proto3.util.equals(UpdateReportFormulaResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.DeleteReportFormulaRequest
 */
export class DeleteReportFormulaRequest extends Message<DeleteReportFormulaRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<DeleteReportFormulaRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DeleteReportFormulaRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteReportFormulaRequest {
    return new DeleteReportFormulaRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteReportFormulaRequest {
    return new DeleteReportFormulaRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteReportFormulaRequest {
    return new DeleteReportFormulaRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteReportFormulaRequest | PlainMessage<DeleteReportFormulaRequest> | undefined, b: DeleteReportFormulaRequest | PlainMessage<DeleteReportFormulaRequest> | undefined): boolean {
    return proto3.util.equals(DeleteReportFormulaRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.DeleteReportFormulaResponse
 */
export class DeleteReportFormulaResponse extends Message<DeleteReportFormulaResponse> {
  constructor(data?: PartialMessage<DeleteReportFormulaResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DeleteReportFormulaResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteReportFormulaResponse {
    return new DeleteReportFormulaResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteReportFormulaResponse {
    return new DeleteReportFormulaResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteReportFormulaResponse {
    return new DeleteReportFormulaResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteReportFormulaResponse | PlainMessage<DeleteReportFormulaResponse> | undefined, b: DeleteReportFormulaResponse | PlainMessage<DeleteReportFormulaResponse> | undefined): boolean {
    return proto3.util.equals(DeleteReportFormulaResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.CheckReportFormulaRequest
 */
export class CheckReportFormulaRequest extends Message<CheckReportFormulaRequest> {
  /**
   * @generated from field: string expression = 1;
   */
  expression = "";

  /**
   * The row to evaluate over, as a stats RPC served it (a report's totals).
   *
   * @generated from field: tracker.v1.StatsRow values = 2;
   */
  values?: StatsRow;

  constructor(data?: PartialMessage<CheckReportFormulaRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CheckReportFormulaRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "expression", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "values", kind: "message", T: StatsRow },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckReportFormulaRequest {
    return new CheckReportFormulaRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckReportFormulaRequest {
    return new CheckReportFormulaRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckReportFormulaRequest {
    return new CheckReportFormulaRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CheckReportFormulaRequest | PlainMessage<CheckReportFormulaRequest> | undefined, b: CheckReportFormulaRequest | PlainMessage<CheckReportFormulaRequest> | undefined): boolean {
    return proto3.util.equals(CheckReportFormulaRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.CheckReportFormulaResponse
 */
export class CheckReportFormulaResponse extends Message<CheckReportFormulaResponse> {
  /**
   * The canonical text the formula would be saved as.
   *
   * @generated from field: string expression = 1;
   */
  expression = "";

  /**
   * The metric keys it reads.
   *
   * @generated from field: repeated string operand_keys = 2;
   */
  operandKeys: string[] = [];

  /**
   * The value over CheckReportFormulaRequest.values; absent when blank («—»:
   * a division by zero, a blank operand of a product or quotient).
   *
   * @generated from field: optional string value = 3;
   */
  value?: string;

  constructor(data?: PartialMessage<CheckReportFormulaResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CheckReportFormulaResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "expression", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "operand_keys", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckReportFormulaResponse {
    return new CheckReportFormulaResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckReportFormulaResponse {
    return new CheckReportFormulaResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckReportFormulaResponse {
    return new CheckReportFormulaResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CheckReportFormulaResponse | PlainMessage<CheckReportFormulaResponse> | undefined, b: CheckReportFormulaResponse | PlainMessage<CheckReportFormulaResponse> | undefined): boolean {
    return proto3.util.equals(CheckReportFormulaResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetReportingSchemaRequest
 */
export class GetReportingSchemaRequest extends Message<GetReportingSchemaRequest> {
  constructor(data?: PartialMessage<GetReportingSchemaRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetReportingSchemaRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetReportingSchemaRequest {
    return new GetReportingSchemaRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetReportingSchemaRequest {
    return new GetReportingSchemaRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetReportingSchemaRequest {
    return new GetReportingSchemaRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetReportingSchemaRequest | PlainMessage<GetReportingSchemaRequest> | undefined, b: GetReportingSchemaRequest | PlainMessage<GetReportingSchemaRequest> | undefined): boolean {
    return proto3.util.equals(GetReportingSchemaRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetReportingSchemaResponse
 */
export class GetReportingSchemaResponse extends Message<GetReportingSchemaResponse> {
  /**
   * @generated from field: repeated tracker.v1.MetricDefinition metrics = 1;
   */
  metrics: MetricDefinition[] = [];

  /**
   * @generated from field: repeated tracker.v1.DimensionDefinition dimensions = 2;
   */
  dimensions: DimensionDefinition[] = [];

  /**
   * system + workspace-default views
   *
   * @generated from field: repeated tracker.v1.ReportView presets = 3;
   */
  presets: ReportView[] = [];

  /**
   * user default → workspace default → system preset
   *
   * @generated from field: string default_view_id = 4;
   */
  defaultViewId = "";

  /**
   * @generated from field: string primary_goal_key = 5;
   */
  primaryGoalKey = "";

  /**
   * The workspace's own formulas, for the editor; their values are served as
   * metrics (category "custom") like any other.
   *
   * @generated from field: repeated tracker.v1.ReportFormula formulas = 6;
   */
  formulas: ReportFormula[] = [];

  constructor(data?: PartialMessage<GetReportingSchemaResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetReportingSchemaResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "metrics", kind: "message", T: MetricDefinition, repeated: true },
    { no: 2, name: "dimensions", kind: "message", T: DimensionDefinition, repeated: true },
    { no: 3, name: "presets", kind: "message", T: ReportView, repeated: true },
    { no: 4, name: "default_view_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "primary_goal_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "formulas", kind: "message", T: ReportFormula, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetReportingSchemaResponse {
    return new GetReportingSchemaResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetReportingSchemaResponse {
    return new GetReportingSchemaResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetReportingSchemaResponse {
    return new GetReportingSchemaResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetReportingSchemaResponse | PlainMessage<GetReportingSchemaResponse> | undefined, b: GetReportingSchemaResponse | PlainMessage<GetReportingSchemaResponse> | undefined): boolean {
    return proto3.util.equals(GetReportingSchemaResponse, a, b);
  }
}

/**
 * MetricFormula is the derived-metric micro-AST. Operands are metric keys
 * (base or derived); the server ships definitions pre-topo-sorted so clients
 * evaluate in list order.
 *
 * @generated from message tracker.v1.MetricFormula
 */
export class MetricFormula extends Message<MetricFormula> {
  /**
   * @generated from field: tracker.v1.FormulaOp op = 1;
   */
  op = FormulaOp.UNSPECIFIED;

  /**
   * @generated from field: repeated string operand_keys = 2;
   */
  operandKeys: string[] = [];

  /**
   * expression is the canonical text of a FORMULA_OP_EXPRESSION formula.
   *
   * @generated from field: string expression = 3;
   */
  expression = "";

  constructor(data?: PartialMessage<MetricFormula>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.MetricFormula";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "op", kind: "enum", T: proto3.getEnumType(FormulaOp) },
    { no: 2, name: "operand_keys", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "expression", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MetricFormula {
    return new MetricFormula().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MetricFormula {
    return new MetricFormula().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MetricFormula {
    return new MetricFormula().fromJsonString(jsonString, options);
  }

  static equals(a: MetricFormula | PlainMessage<MetricFormula> | undefined, b: MetricFormula | PlainMessage<MetricFormula> | undefined): boolean {
    return proto3.util.equals(MetricFormula, a, b);
  }
}

/**
 * @generated from message tracker.v1.MetricDefinition
 */
export class MetricDefinition extends Message<MetricDefinition> {
  /**
   * "clicks", "goal.dep.count", "reg2dep"
   *
   * @generated from field: string key = 1;
   */
  key = "";

  /**
   * @generated from field: string label = 2;
   */
  label = "";

  /**
   * @generated from field: string short_label = 3;
   */
  shortLabel = "";

  /**
   * @generated from field: tracker.v1.MetricFormat format = 4;
   */
  format = MetricFormat.UNSPECIFIED;

  /**
   * @generated from field: tracker.v1.MetricKind kind = 5;
   */
  kind = MetricKind.UNSPECIFIED;

  /**
   * DERIVED only
   *
   * @generated from field: tracker.v1.MetricFormula formula = 6;
   */
  formula?: MetricFormula;

  /**
   * traffic | goals | revenue | derived
   *
   * @generated from field: string category = 7;
   */
  category = "";

  /**
   * set on goal-generated metrics
   *
   * @generated from field: string goal_key = 8;
   */
  goalKey = "";

  /**
   * @generated from field: int32 sort_order = 9;
   */
  sortOrder = 0;

  /**
   * tone-color the value (profit-style +/-)
   *
   * @generated from field: bool emphasis = 10;
   */
  emphasis = false;

  /**
   * description says what the number means — the column header tooltip.
   *
   * @generated from field: string description = 11;
   */
  description = "";

  /**
   * Digits after the decimal point the value is shown with.
   *
   * @generated from field: int32 decimals = 12;
   */
  decimals = 0;

  /**
   * @generated from field: tracker.v1.MetricDirection better = 13;
   */
  better = MetricDirection.UNSPECIFIED;

  constructor(data?: PartialMessage<MetricDefinition>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.MetricDefinition";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "short_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "format", kind: "enum", T: proto3.getEnumType(MetricFormat) },
    { no: 5, name: "kind", kind: "enum", T: proto3.getEnumType(MetricKind) },
    { no: 6, name: "formula", kind: "message", T: MetricFormula },
    { no: 7, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "goal_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "emphasis", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "decimals", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "better", kind: "enum", T: proto3.getEnumType(MetricDirection) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MetricDefinition {
    return new MetricDefinition().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MetricDefinition {
    return new MetricDefinition().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MetricDefinition {
    return new MetricDefinition().fromJsonString(jsonString, options);
  }

  static equals(a: MetricDefinition | PlainMessage<MetricDefinition> | undefined, b: MetricDefinition | PlainMessage<MetricDefinition> | undefined): boolean {
    return proto3.util.equals(MetricDefinition, a, b);
  }
}

/**
 * @generated from message tracker.v1.DimensionDefinition
 */
export class DimensionDefinition extends Message<DimensionDefinition> {
  /**
   * campaign | source | ad_campaign | ad_set | creative | placement |
   * sub1..sub20 | flow | node | step | branch | landing | offer | network |
   * country | region | city | language | device | os | browser |
   * device_model | isp | asn | connection | ip_subnet | referrer | hour |
   * weekday | day | week | month | goal | status | traffic_class | bot_reason
   *
   * @generated from field: string key = 1;
   */
  key = "";

  /**
   * @generated from field: string label = 2;
   */
  label = "";

  /**
   * false for step-view-only dimensions
   *
   * @generated from field: bool drilldownable = 3;
   */
  drilldownable = false;

  /**
   * The picker section: source | path | geo | device | network | time |
   * conversion | quality.
   *
   * @generated from field: string group = 4;
   */
  group = "";

  /**
   * A conversion's own attribute (goal, status). Grouped by one, a report
   * carries conversion metrics only; filtered by one, it narrows the
   * conversions and never the clicks they are divided by.
   *
   * @generated from field: bool conversion_only = 5;
   */
  conversionOnly = false;

  constructor(data?: PartialMessage<DimensionDefinition>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DimensionDefinition";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "drilldownable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "group", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "conversion_only", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DimensionDefinition {
    return new DimensionDefinition().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DimensionDefinition {
    return new DimensionDefinition().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DimensionDefinition {
    return new DimensionDefinition().fromJsonString(jsonString, options);
  }

  static equals(a: DimensionDefinition | PlainMessage<DimensionDefinition> | undefined, b: DimensionDefinition | PlainMessage<DimensionDefinition> | undefined): boolean {
    return proto3.util.equals(DimensionDefinition, a, b);
  }
}

/**
 * DimensionFilter narrows a report or the campaign list to the rows whose
 * value of a dimension passes. Values are compared with the exact strings a
 * report row's dimension_path carries (a campaign's id, a country code).
 *
 * @generated from message tracker.v1.DimensionFilter
 */
export class DimensionFilter extends Message<DimensionFilter> {
  /**
   * @generated from field: string dimension_key = 1;
   */
  dimensionKey = "";

  /**
   * @generated from field: tracker.v1.DimensionFilterOp op = 2;
   */
  op = DimensionFilterOp.UNSPECIFIED;

  /**
   * @generated from field: repeated string values = 3;
   */
  values: string[] = [];

  constructor(data?: PartialMessage<DimensionFilter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DimensionFilter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dimension_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "op", kind: "enum", T: proto3.getEnumType(DimensionFilterOp) },
    { no: 3, name: "values", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DimensionFilter {
    return new DimensionFilter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DimensionFilter {
    return new DimensionFilter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DimensionFilter {
    return new DimensionFilter().fromJsonString(jsonString, options);
  }

  static equals(a: DimensionFilter | PlainMessage<DimensionFilter> | undefined, b: DimensionFilter | PlainMessage<DimensionFilter> | undefined): boolean {
    return proto3.util.equals(DimensionFilter, a, b);
  }
}

/**
 * MetricFilter is a condition on a computed metric — the HAVING of a report:
 * "ROI < 0", "Расход > 150". value is a decimal in the metric's own unit as
 * StatsRow serves it (a percent metric is a ratio: 0.5 is 50%). A row whose
 * metric is blank ("—") never passes.
 *
 * @generated from message tracker.v1.MetricFilter
 */
export class MetricFilter extends Message<MetricFilter> {
  /**
   * @generated from field: string metric_key = 1;
   */
  metricKey = "";

  /**
   * @generated from field: tracker.v1.MetricFilterOp op = 2;
   */
  op = MetricFilterOp.UNSPECIFIED;

  /**
   * @generated from field: string value = 3;
   */
  value = "";

  constructor(data?: PartialMessage<MetricFilter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.MetricFilter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "metric_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "op", kind: "enum", T: proto3.getEnumType(MetricFilterOp) },
    { no: 3, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MetricFilter {
    return new MetricFilter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MetricFilter {
    return new MetricFilter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MetricFilter {
    return new MetricFilter().fromJsonString(jsonString, options);
  }

  static equals(a: MetricFilter | PlainMessage<MetricFilter> | undefined, b: MetricFilter | PlainMessage<MetricFilter> | undefined): boolean {
    return proto3.util.equals(MetricFilter, a, b);
  }
}

/**
 * StatsRow is the dynamic metric bag every stats RPC returns: metric key →
 * decimal string. Derived metrics are included server-side; clients re-derive
 * after client-side aggregation. Absent key = not computable (e.g. ratio with
 * zero denominator) — render as "—".
 *
 * @generated from message tracker.v1.StatsRow
 */
export class StatsRow extends Message<StatsRow> {
  /**
   * @generated from field: map<string, string> values = 1;
   */
  values: { [key: string]: string } = {};

  constructor(data?: PartialMessage<StatsRow>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.StatsRow";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "values", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StatsRow {
    return new StatsRow().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StatsRow {
    return new StatsRow().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StatsRow {
    return new StatsRow().fromJsonString(jsonString, options);
  }

  static equals(a: StatsRow | PlainMessage<StatsRow> | undefined, b: StatsRow | PlainMessage<StatsRow> | undefined): boolean {
    return proto3.util.equals(StatsRow, a, b);
  }
}

/**
 * ReportView is a saved view of a report, of the campaign list or a saved
 * column set (definition.surface). scope=system rows are seeded per preset
 * and read-only; a user row is its author's alone; a workspace row is seen
 * by every member and changed by its author only («другие смогут открыть и
 * скопировать, менять — только вы»).
 *
 * @generated from message tracker.v1.ReportView
 */
export class ReportView extends Message<ReportView> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * system | workspace | user
   *
   * @generated from field: string scope = 3;
   */
  scope = "";

  /**
   * system presets: which preset this seeds
   *
   * @generated from field: string preset = 4;
   */
  preset = "";

  /**
   * @generated from field: tracker.v1.ReportViewDefinition definition = 5;
   */
  definition?: ReportViewDefinition;

  /**
   * @generated from field: bool is_default = 6;
   */
  isDefault = false;

  /**
   * The author (a Keycloak sub; names: WorkspaceService.GetPeopleNames), ""
   * for system presets and for shared views saved before authors were kept.
   *
   * @generated from field: string owner_id = 7;
   */
  ownerId = "";

  /**
   * Whether the caller may update or delete it.
   *
   * @generated from field: bool can_edit = 8;
   */
  canEdit = false;

  /**
   * RFC 3339.
   *
   * @generated from field: string created_at = 9;
   */
  createdAt = "";

  /**
   * @generated from field: string updated_at = 10;
   */
  updatedAt = "";

  constructor(data?: PartialMessage<ReportView>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ReportView";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "scope", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "preset", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "definition", kind: "message", T: ReportViewDefinition },
    { no: 6, name: "is_default", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "owner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "can_edit", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportView {
    return new ReportView().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportView {
    return new ReportView().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportView {
    return new ReportView().fromJsonString(jsonString, options);
  }

  static equals(a: ReportView | PlainMessage<ReportView> | undefined, b: ReportView | PlainMessage<ReportView> | undefined): boolean {
    return proto3.util.equals(ReportView, a, b);
  }
}

/**
 * @generated from message tracker.v1.ReportViewDefinition
 */
export class ReportViewDefinition extends Message<ReportViewDefinition> {
  /**
   * ordered columns; unknown keys dropped at read
   *
   * @generated from field: repeated string metric_keys = 1;
   */
  metricKeys: string[] = [];

  /**
   * outermost first, max 4
   *
   * @generated from field: repeated string dimension_keys = 2;
   */
  dimensionKeys: string[] = [];

  /**
   * @generated from field: string sort_metric_key = 4;
   */
  sortMetricKey = "";

  /**
   * @generated from field: bool sort_desc = 5;
   */
  sortDesc = false;

  /**
   * report (default) | campaigns — which screen the view belongs to — or
   * columns: a saved column set («Сохранить набор»), metric_keys only, shown
   * on both screens.
   *
   * @generated from field: string surface = 6;
   */
  surface = "";

  /**
   * @generated from field: repeated tracker.v1.DimensionFilter dimension_filters = 7;
   */
  dimensionFilters: DimensionFilter[] = [];

  /**
   * @generated from field: repeated tracker.v1.MetricFilter metric_filters = 8;
   */
  metricFilters: MetricFilter[] = [];

  /**
   * The campaign list's folding: "" (flat) | group | source | owner | offer.
   *
   * @generated from field: string grouping = 9;
   */
  grouping = "";

  /**
   * The comparison period: "" (none) | prev | year.
   *
   * @generated from field: string compare = 10;
   */
  compare = "";

  /**
   * The campaign list's status filter: ACTIVE | PAUSED | DRAFT | ARCHIVED.
   *
   * @generated from field: repeated string statuses = 11;
   */
  statuses: string[] = [];

  /**
   * A report's own period («Запомнить период»); unset = the Top bar's. The
   * campaign list never keeps one — its period is the Top bar's.
   *
   * @generated from field: tracker.v1.DateRange period = 12;
   */
  period?: DateRange;

  /**
   * A report's «Конверсии по»: "" (дате лида, the default) | lead_time |
   * conversion_time | click_time — AttributionBasis by name.
   *
   * @generated from field: string attribution_basis = 13;
   */
  attributionBasis = "";

  /**
   * The campaign list's quick view the view was saved on (board CampList:
   * Сливают · Нет кликов · Холд > 50%) — ListCampaignsRequest.quick by name;
   * "" = none. The archive is a status (statuses), not a quick view. A
   * report keeps none.
   *
   * @generated from field: string quick = 14;
   */
  quick = "";

  constructor(data?: PartialMessage<ReportViewDefinition>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ReportViewDefinition";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "metric_keys", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "dimension_keys", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "sort_metric_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "sort_desc", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "surface", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "dimension_filters", kind: "message", T: DimensionFilter, repeated: true },
    { no: 8, name: "metric_filters", kind: "message", T: MetricFilter, repeated: true },
    { no: 9, name: "grouping", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "compare", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "statuses", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 12, name: "period", kind: "message", T: DateRange },
    { no: 13, name: "attribution_basis", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "quick", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportViewDefinition {
    return new ReportViewDefinition().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportViewDefinition {
    return new ReportViewDefinition().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportViewDefinition {
    return new ReportViewDefinition().fromJsonString(jsonString, options);
  }

  static equals(a: ReportViewDefinition | PlainMessage<ReportViewDefinition> | undefined, b: ReportViewDefinition | PlainMessage<ReportViewDefinition> | undefined): boolean {
    return proto3.util.equals(ReportViewDefinition, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListReportViewsRequest
 */
export class ListReportViewsRequest extends Message<ListReportViewsRequest> {
  /**
   * report | campaigns; empty = every view.
   *
   * @generated from field: string surface = 1;
   */
  surface = "";

  constructor(data?: PartialMessage<ListReportViewsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListReportViewsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "surface", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListReportViewsRequest {
    return new ListReportViewsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListReportViewsRequest {
    return new ListReportViewsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListReportViewsRequest {
    return new ListReportViewsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListReportViewsRequest | PlainMessage<ListReportViewsRequest> | undefined, b: ListReportViewsRequest | PlainMessage<ListReportViewsRequest> | undefined): boolean {
    return proto3.util.equals(ListReportViewsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListReportViewsResponse
 */
export class ListReportViewsResponse extends Message<ListReportViewsResponse> {
  /**
   * @generated from field: repeated tracker.v1.ReportView items = 1;
   */
  items: ReportView[] = [];

  constructor(data?: PartialMessage<ListReportViewsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListReportViewsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: ReportView, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListReportViewsResponse {
    return new ListReportViewsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListReportViewsResponse {
    return new ListReportViewsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListReportViewsResponse {
    return new ListReportViewsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListReportViewsResponse | PlainMessage<ListReportViewsResponse> | undefined, b: ListReportViewsResponse | PlainMessage<ListReportViewsResponse> | undefined): boolean {
    return proto3.util.equals(ListReportViewsResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateReportViewRequest
 */
export class CreateReportViewRequest extends Message<CreateReportViewRequest> {
  /**
   * A name the caller already uses for another view of the same reach gets
   * « (2)», « (3)» … — the view is saved, never refused for its name.
   *
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: tracker.v1.ReportViewDefinition definition = 2;
   */
  definition?: ReportViewDefinition;

  /**
   * true → scope=workspace, else user
   *
   * @generated from field: bool workspace_shared = 3;
   */
  workspaceShared = false;

  constructor(data?: PartialMessage<CreateReportViewRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateReportViewRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "definition", kind: "message", T: ReportViewDefinition },
    { no: 3, name: "workspace_shared", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateReportViewRequest {
    return new CreateReportViewRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateReportViewRequest {
    return new CreateReportViewRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateReportViewRequest {
    return new CreateReportViewRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateReportViewRequest | PlainMessage<CreateReportViewRequest> | undefined, b: CreateReportViewRequest | PlainMessage<CreateReportViewRequest> | undefined): boolean {
    return proto3.util.equals(CreateReportViewRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateReportViewResponse
 */
export class CreateReportViewResponse extends Message<CreateReportViewResponse> {
  /**
   * @generated from field: tracker.v1.ReportView view = 1;
   */
  view?: ReportView;

  constructor(data?: PartialMessage<CreateReportViewResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateReportViewResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "view", kind: "message", T: ReportView },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateReportViewResponse {
    return new CreateReportViewResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateReportViewResponse {
    return new CreateReportViewResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateReportViewResponse {
    return new CreateReportViewResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateReportViewResponse | PlainMessage<CreateReportViewResponse> | undefined, b: CreateReportViewResponse | PlainMessage<CreateReportViewResponse> | undefined): boolean {
    return proto3.util.equals(CreateReportViewResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateReportViewRequest
 */
export class UpdateReportViewRequest extends Message<UpdateReportViewRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: tracker.v1.ReportViewDefinition definition = 3;
   */
  definition?: ReportViewDefinition;

  constructor(data?: PartialMessage<UpdateReportViewRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateReportViewRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "definition", kind: "message", T: ReportViewDefinition },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateReportViewRequest {
    return new UpdateReportViewRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateReportViewRequest {
    return new UpdateReportViewRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateReportViewRequest {
    return new UpdateReportViewRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateReportViewRequest | PlainMessage<UpdateReportViewRequest> | undefined, b: UpdateReportViewRequest | PlainMessage<UpdateReportViewRequest> | undefined): boolean {
    return proto3.util.equals(UpdateReportViewRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateReportViewResponse
 */
export class UpdateReportViewResponse extends Message<UpdateReportViewResponse> {
  /**
   * @generated from field: tracker.v1.ReportView view = 1;
   */
  view?: ReportView;

  constructor(data?: PartialMessage<UpdateReportViewResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateReportViewResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "view", kind: "message", T: ReportView },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateReportViewResponse {
    return new UpdateReportViewResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateReportViewResponse {
    return new UpdateReportViewResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateReportViewResponse {
    return new UpdateReportViewResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateReportViewResponse | PlainMessage<UpdateReportViewResponse> | undefined, b: UpdateReportViewResponse | PlainMessage<UpdateReportViewResponse> | undefined): boolean {
    return proto3.util.equals(UpdateReportViewResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.DeleteReportViewRequest
 */
export class DeleteReportViewRequest extends Message<DeleteReportViewRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<DeleteReportViewRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DeleteReportViewRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteReportViewRequest {
    return new DeleteReportViewRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteReportViewRequest {
    return new DeleteReportViewRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteReportViewRequest {
    return new DeleteReportViewRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteReportViewRequest | PlainMessage<DeleteReportViewRequest> | undefined, b: DeleteReportViewRequest | PlainMessage<DeleteReportViewRequest> | undefined): boolean {
    return proto3.util.equals(DeleteReportViewRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.DeleteReportViewResponse
 */
export class DeleteReportViewResponse extends Message<DeleteReportViewResponse> {
  constructor(data?: PartialMessage<DeleteReportViewResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DeleteReportViewResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteReportViewResponse {
    return new DeleteReportViewResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteReportViewResponse {
    return new DeleteReportViewResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteReportViewResponse {
    return new DeleteReportViewResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteReportViewResponse | PlainMessage<DeleteReportViewResponse> | undefined, b: DeleteReportViewResponse | PlainMessage<DeleteReportViewResponse> | undefined): boolean {
    return proto3.util.equals(DeleteReportViewResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.SetDefaultReportViewRequest
 */
export class SetDefaultReportViewRequest extends Message<SetDefaultReportViewRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<SetDefaultReportViewRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.SetDefaultReportViewRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetDefaultReportViewRequest {
    return new SetDefaultReportViewRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetDefaultReportViewRequest {
    return new SetDefaultReportViewRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetDefaultReportViewRequest {
    return new SetDefaultReportViewRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetDefaultReportViewRequest | PlainMessage<SetDefaultReportViewRequest> | undefined, b: SetDefaultReportViewRequest | PlainMessage<SetDefaultReportViewRequest> | undefined): boolean {
    return proto3.util.equals(SetDefaultReportViewRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.SetDefaultReportViewResponse
 */
export class SetDefaultReportViewResponse extends Message<SetDefaultReportViewResponse> {
  constructor(data?: PartialMessage<SetDefaultReportViewResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.SetDefaultReportViewResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetDefaultReportViewResponse {
    return new SetDefaultReportViewResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetDefaultReportViewResponse {
    return new SetDefaultReportViewResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetDefaultReportViewResponse {
    return new SetDefaultReportViewResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SetDefaultReportViewResponse | PlainMessage<SetDefaultReportViewResponse> | undefined, b: SetDefaultReportViewResponse | PlainMessage<SetDefaultReportViewResponse> | undefined): boolean {
    return proto3.util.equals(SetDefaultReportViewResponse, a, b);
  }
}

